@if (show) {
<div class="spinnerAreaOverlay">
  <div class="row w-100 g-0 horizontal-align-{{hAlignMessage}} vertical-align-{{vAlignMessage}}">
    <div
      [class.text-center]="hAlignMessage === 'center'"
      [class.col-12]="hAlignMessage === 'center'"
      class="col-auto align-self-center"
    >
      <div>
        <mat-progress-spinner
          class="mobi-section-spinner"
          diameter="40"
          mode="indeterminate"
        />
      </div>
    </div>
    <div
      [class.text-center]="hAlignMessage === 'center'"
      [class.col-12]="hAlignMessage === 'center'"
      class="col ellipsis align-self-center"
    >
      <p class="ellipsis">
        {{ message | translate }}
      </p>
    </div>
  </div>
</div>
}